var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuizOpeningRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 720,
    viewBox: "0 0 640 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 720,
    fill: "#2E0B67"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4215 267.123L10.1718 249.952L84.1086 223.042L90.3582 240.212L63.8333 249.867L89.4226 320.173L68.5785 327.759L42.9892 257.453L16.4215 267.123ZM126.273 306.76L102.394 241.153L123.281 233.55L147.16 299.158L126.273 306.76ZM110.076 229.698C107.143 230.765 104.271 230.715 101.459 229.545C98.6365 228.347 96.7227 226.367 95.7173 223.605C94.7224 220.872 94.9261 218.153 96.3285 215.45C97.7206 212.718 99.8831 210.818 102.816 209.751C105.778 208.673 108.655 208.738 111.449 209.946C114.261 211.116 116.164 213.067 117.159 215.801C118.165 218.563 117.971 221.31 116.579 224.042C115.205 226.735 113.038 228.62 110.076 229.698ZM160.455 294.319L136.576 228.712L156.437 221.482L160.821 233.528L161.547 233.263C161.463 228.779 162.625 224.793 165.031 221.305C167.438 217.817 170.891 215.254 175.39 213.617C179.946 211.959 184.272 211.706 188.368 212.86C192.464 214.013 195.669 216.394 197.982 220.002L198.665 219.754C198.47 215.407 199.727 211.418 202.437 207.788C205.136 204.129 208.906 201.418 213.747 199.656C219.954 197.397 225.72 197.556 231.044 200.133C236.357 202.681 240.273 207.415 242.791 214.335L258.866 258.5L237.979 266.103L223.646 226.721C222.454 223.446 220.707 221.26 218.405 220.163C216.093 219.038 213.598 218.962 210.922 219.936C208.045 220.983 206.124 222.747 205.156 225.227C204.207 227.669 204.302 230.456 205.442 233.588L219.698 272.756L199.623 280.063L185.211 240.468C184.102 237.421 182.401 235.315 180.107 234.151C177.813 232.987 175.313 232.897 172.608 233.881C170.785 234.545 169.337 235.572 168.263 236.962C167.179 238.324 166.528 239.948 166.311 241.833C166.123 243.707 166.422 245.726 167.21 247.891L181.342 286.717L160.455 294.319ZM302.927 243.866C296.065 246.364 289.65 247.167 283.682 246.276C277.732 245.345 272.502 242.847 267.99 238.781C263.497 234.677 259.981 229.136 257.442 222.159C254.975 215.382 254.158 208.972 254.99 202.929C255.811 196.858 258.144 191.527 261.987 186.935C265.82 182.315 271.039 178.803 277.646 176.399C282.316 174.699 286.851 173.871 291.253 173.913C295.654 173.956 299.782 174.888 303.638 176.71C307.493 178.531 310.966 181.25 314.055 184.866C317.135 188.453 319.654 192.938 321.613 198.32L323.509 203.531L266.487 224.285L262.072 212.154L299.66 198.474C298.823 196.263 297.576 194.476 295.918 193.112C294.261 191.748 292.359 190.908 290.213 190.593C288.085 190.239 285.867 190.482 283.561 191.321C281.226 192.171 279.324 193.46 277.857 195.187C276.379 196.886 275.426 198.829 274.997 201.017C274.557 203.176 274.718 205.391 275.48 207.661L279.973 220.005C280.947 222.682 282.329 224.839 284.119 226.478C285.898 228.088 287.958 229.095 290.298 229.501C292.639 229.907 295.147 229.623 297.824 228.648C299.675 227.975 301.262 227.107 302.584 226.045C303.907 224.983 304.928 223.757 305.647 222.367C306.367 220.976 306.732 219.456 306.745 217.807L326.125 211.382C326.893 215.972 326.505 220.354 324.96 224.528C323.434 228.663 320.814 232.406 317.1 235.757C313.375 239.08 308.651 241.783 302.927 243.866Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10_3",
    x: 4.08862,
    y: 138.094,
    width: 333.977,
    height: 208.574,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 720,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizOpeningRight);
export default __webpack_public_path__ + "static/media/quiz-opening-right.8d8b391205e8378be3851cab7c84a291.svg";
export { ForwardRef as ReactComponent };